// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
var Version = "2.7.0";
var Internal = /** @class */ (function () {
    /**
     * Constructs a new instance of the internal telemetry data class.
     */
    function Internal(config) {
        this.sdkVersion = (config.sdkExtension && config.sdkExtension() ? config.sdkExtension() + "_" : "") + "javascript:" + Version;
    }
    return Internal;
}());
export { Internal };
//# sourceMappingURL=Internal.js.map